<template>
  <div class="action-btn-group d-inline-flex align-items-center">
    <b-button
      v-if="showView"
      size="sm"
      class="button-circle"
      variant="primary"
      @click="$emit('view')"
      :disabled="disabled"
    >
      <i class="fa fa-eye"></i>
    </b-button>

    <b-button
      v-if="showEdit"
      size="sm"
      class="button-circle btn-orange"
      variant="primary"
      @click="$emit('edit')"
      :disabled="disabled"
    >
      <i class="fa fa-pencil edit"></i>
    </b-button>

    <b-button
      v-if="showDelete"
      size="sm"
      class="button-circle"
      variant="danger"
      @click="$emit('delete')"
      :disabled="disabled"
    >
      <i class="fa fa-trash"></i>
    </b-button>

    <slot />
  </div>
</template>

<script>
export default {
  name: "ActionButtonGroup",
  props: {
    showView: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
